<template lang="pug">
  div
    .modal-card(style='width: auto')
      header.modal-card-head
        p.modal-card-title Collected
      section.modal-card-body
        .content
          p Filter the pokedex by selecting any of the collection types.
          p Shows collected pokemons.
      footer.modal-card-foot
        button.button(type='button', @click='$parent.close()') Close
</template>

<script>
export default {
  name: 'CollectedHelp',
};
</script>

<style lang="scss" scoped></style>
